export default __webpack_public_path__ + "static/media/star.d652c02c.svg";